import React from 'react';
import logo from '@/assets/logo.png';

interface LogoProps {
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    xs: 'w-16',
    sm: 'w-24',
    md: 'w-32',
    lg: 'w-48',
    xl: 'w-96'
  };

  return (
    <img
      src={logo}
      alt="Vigikus Logo"
      className={`${sizeClasses[size]} ${className} aspect-[2172/724] object-contain`}
    />
  );
};

export default Logo;
